export const environment = {
  production: true,
  buildId: '2844500279519481',
  configFile: 'config.json',
};
